import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

export const AdditivesForClinkerClassificationRow = ({material}: {material: Material}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.category}</Typography>
    </TableCell>
  </>
)
